import React from "react";

export const ConfidentialityPartnersOffersInformationOptOut = () => {
  return (
    <div>
      <strong>Non, je ne souhaite pas recevoir</strong> ces communications et{" "}
      <strong>renonce aux offres et remises proposées</strong>
    </div>
  );
};
